/**
 * Stylesheet rule for the `ledger` edge type (LEDGER01, ALGORITHM_FRONTEND_CONTRACT section 5).
 *
 * The backend declares meaning only: `edge_type: "ledger"`, a transfer the run read between two wallets already on
 * the case that no other edge covers. Everything about how that looks lives here (R23): the lowest tier, a thin,
 * light, dashed, arrowless line that sits under every finding edge. Shown at `level=low`, folded at `level=high`
 * by the backend. No opacity is set here (R11): the line is faint by its colour and width.
 */

export const LEDGER_EDGE_TYPE = 'ledger';

/** Cytoscape rules; spread into the canvas stylesheet after the money-flow base rule. */
export function ledgerEdgeStyles(isDark: boolean): Array<{ selector: string; style: Record<string, unknown> }> {
  const style = {
    'width': 0.75,
    'line-color': isDark ? '#3f3f46' : '#cbd5e1',
    'line-style': 'dashed',
    'line-dash-pattern': [3, 4],
    'target-arrow-shape': 'none',
    'source-arrow-shape': 'none',
    'curve-style': 'bezier',
  };
  return [
    { selector: `edge[edge_type = "${LEDGER_EDGE_TYPE}"]`, style },
    { selector: `edge[edgeType = "${LEDGER_EDGE_TYPE}"]`, style },
  ];
}
